import { useApiQuery } from '@portals-platform/api-client';
import { useMemo } from 'react';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CountryAssuredsResponse } from '../api/responses.js';
import { toAssuredsByCountry } from '../mappers/mappers.js';
import { queryKeys } from '../query-keys.js';

export function useAssuredsByCountry(): Record<string, string[]> {
  const { data } = useApiQuery<CountryAssuredsResponse>(
    [...queryKeys.countryAssureds()],
    ENDPOINTS.countryAssureds,
  );

  return useMemo(() => toAssuredsByCountry(data), [data]);
}
